import React from "react";
import { Box, CheckboxProps } from "@mui/material";
import { ITagBroker } from "src/api/server/extended-search";
import { CheckboxWithLabel } from "src/theme-mui/components/checkbox/checkbox-with-label";

export type IBrokerOnChangeParams = { isChecked: boolean; brokerId: string };

interface IBrokerCheckbox extends Omit<CheckboxProps, "onChange" | "checked"> {
    onChange: (props: IBrokerOnChangeParams) => void;
    isChecked: boolean;
    broker: ITagBroker;
}

export const BrokerCheckbox = ({ broker, isChecked, onChange, ...checkboxProps }: IBrokerCheckbox) => {
    return (
        <CheckboxWithLabel
            checkboxProps={{
                ...checkboxProps,
                checked: isChecked,
                id: `broker-checkbox-${broker.brokerId}`,
                name: `broker-checkbox-${broker.brokerId}`,
                onChange: event => {
                    onChange({ isChecked: event.target.checked, brokerId: broker.brokerId });
                },
            }}
            label={<Box component="img" src={broker.logoUrl} alt={broker.partnerName} sx={{ height: "16px", width: "auto" }} />}
            sx={{ whiteSpace: "nowrap" }}
        />
    );
};
